import { makeStyles } from "@material-ui/core";

const useStyle = makeStyles((theme) => ({
  pageMain: {
    backgroundColor: theme.palette.background.dark,
    marginBottom: '-7rem',
    paddingTop: 50,
    paddingBottom: 20,
    // display: 'flex',
    // justifyContent: 'center'
  },
  contentContainer: {
    padding: '0px 20px',
    maxWidth: 1400,
    margin: '0 auto'
  },
  cardPaperMain: {
    height: '100%',
    boxShadow: '0px 0px 35px rgba(11, 58, 101, 0.25)',
    border: `1px solid ${theme.palette.background.paper}`,
    "&:hover": {
      border: '1px solid #0D8BFF',
    },
    [theme.breakpoints.down(840)]: {
      boxShadow: '0px 0px 15px rgba(11, 58, 101, 0.2)',
      border: '1px solid #0D8BFF',
      borderRadius: '10px',
    },

  },
  expireDate: {
    height: '15px',
    fontSize: '12px',
    color: '#0D8BFF',
    textAlign: 'center',
    marginBottom: 30,
    paddingTop: 5
  },
  lockContainer: {
    height: '100%',
    width: '100%',
    position: 'absolute',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
  },
  lockContent: {
    filter: 'blur(7px)',
    pointerEvents: 'none',
    userSelect: 'none'
  },
  startButton: {
    backgroundColor: theme.palette.primary.main,
    padding: '5px 7px',
    maxwidth: "50%",
    minWidth: "40%",
    marginTop: 50,
    border: 0,
    color: 'white',
    fontWeight: 600
  },
  startButton2: {
    backgroundColor: theme.palette.primary.main,
    padding: '5px 7px',
    maxwidth: "50%",
    minWidth: "40%",
    marginTop: 20,
    marginBottom: 30,
    border: 0,
    color: 'white',
    fontWeight: 600
  },
  containerCard: {
    padding: '50px 40px 30px 40px',
    [theme.breakpoints.down(840)]: {
      padding: '30px 20px 10px 20px',
    },
    [theme.breakpoints.down(550)]: {
      padding: '30px 10px 10px 10px',
    }
  }
}))

export default useStyle;